<template>
  <card class="w-100" v-if="isVisible">
    <template slot="header">
      <h4 class="card-title" v-if="isDetail === 'edit'">광고 상세보기</h4>
    </template>
    <template slot="header">
      <h4 class="card-title" v-if="isDetail === 'pre'">이전 광고 상세보기</h4>
    </template>
    <el-form class="form-horizontal" :model="media" :rules="rules" :show-message="false" ref="media" label-width="120px">
      <el-row v-if="isDetail === 'edit' || isDetail === 'pre'">
        <el-col :span="12" class="text-center">
          <img
            v-bind:src="'/api/common/path/' + this.media.filePath + '?name='+ encodeURI(encodeURIComponent(this.media.fileName))"
            style="width: 380px"/>
        </el-col>
        <el-col :span="12" class="text-center1">
          <map-component v-if="mapView" ref="detailMap" :width="380" :read-only="true" :media-type="media.mediaType"
                         :store-seq="media.storeSeq" :store-floor-seq="media.storeFloorSeq"></map-component>
        </el-col>
      </el-row>
      <el-row class="mt-3">
        <el-col :span="8">
          <el-form-item label="지역" prop="areaSeq">
            <el-select style="width:100%" :size="formSize" v-model="media.areaSeq" placeholder="지역 선택" @change="changeArea"
                       :disabled="isDetail === 'edit' || isDetail === 'edit' || isDetail === 'pre'">
              <el-option
                key=""
                label="전체"
                value="">
              </el-option>
              <el-option
                v-for="item in $store.state.store.areas"
                :key="item.areaSeq"
                :label="item.areaName"
                :value="item.areaSeq">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="점포" prop="storeSeq">
            <el-select style="width:100%" :size="formSize" v-model="media.storeSeq" placeholder="점포 선택" filterable @change="changeStore"
                       :disabled="isDetail === 'edit' || isDetail === 'pre'">
              <el-option
                v-for="item in $store.state.store.stores"
                :key="item.storeSeq"
                :label="item.storeName"
                :value="item.storeSeq">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="상품명" prop="goodsName">
            <el-input :size="formSize" v-model="media.goodsName" :disabled="isDetail === 'pre'"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="광고주 분류">
            <el-select style="width:100%" :size="formSize" v-model="searchCompanyName" placeholder="검색조건을 선택하세요."
                       @change="changeCompanyName" :disabled="isDetail === 'pre'">
              <el-option
                v-for="item in keywordOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="광고주" prop="companySeq">
            <el-select style="width:100%" :size="formSize" v-model="media.companySeq" placeholder="광고주를 선택하세요." filterable
                       @change="changeCompany" :disabled="isDetail === 'pre'">
              <el-option
                v-for="item in this.$store.state.settingsCompany.company"
                :key="item.companySeq"
                :label="item.companyName"
                :value="item.companySeq">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="사업자등록번호">
            <el-input :size="formSize" v-model="media.licenseNumber" :readonly="true"
                      :disabled="isDetail === 'pre'"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="mt-3">
        <el-col :span="8">
          <el-form-item label="매체구분" prop="mediaType">
            <el-select style="width:100%" :size="formSize" v-model="media.mediaType" @change="getMediaInfos"
                       :disabled="isDetail === 'pre'">
              <el-option
                key="WC"
                value="WC"
                label="와이드칼라"></el-option>
              <el-option
                key="DM"
                value="DM"
                label="디지털미디어"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="광고매체" prop="mediaInfoSeq">
            <el-select style="width:100%" :size="formSize" v-model="media.mediaInfoSeq" @change="changeMedia"
                       :disabled="isDetail === 'pre'">
              <el-option v-for="item in $store.state.media.mediaInfos"
                         :key="item.mediaInfoSeq"
                         :label="item.mediaName"
                         :value="item.mediaInfoSeq"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="media.mediaType === 'WC'">
          <el-form-item label="조명여부" prop="isLight">
            <el-switch :size="formSize" v-model="media.isLight" :disabled="isDetail === 'pre'"></el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="media.mediaType === 'DM'">
          <el-form-item label="송출시간" prop="duration">
            <el-input :size="formSize" v-model="media.duration" :disabled="isDetail === 'pre'"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="넓이(mm)" prop="width">
            <el-input :size="formSize" v-model="media.width" :disabled="isDetail === 'pre'"
                      @keyup.native="changeWidth"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="높이(mm)" prop="height">
            <el-input :size="formSize" v-model="media.height" :disabled="isDetail === 'pre'"
                      @keyup.native="changeHeight"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="0" class="mt-3">
        <el-col :span="8">
          <el-form-item label="현황구분" prop="profit">
            <el-select style="width:100%" :size="formSize" @change="changeProfit" v-model="media.profit" :disabled="isDetail === 'pre'">
              <el-option
                label="수익"
                value="INCOMING"></el-option>
              <el-option
                label="PL"
                value="PL"></el-option>
              <el-option
                label="공실"
                value="EMPTY"></el-option>
              <el-option
                label="제휴"
                value="AFFILIZATION"></el-option>
              <el-option
                label="기타"
                value="ETC"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="연광고료(원)" prop="prepaymentPrice">
            <el-input :size="formSize" v-model="media.prepaymentPrice" :disabled="isDetail === 'pre'"
                      @keyup.native="changePrepaymentPrice"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="월광고료(원)" prop="installmentPrice">
            <el-input :size="formSize" v-model="media.installmentPrice" :disabled="isDetail === 'pre'"
                      @keyup.native="changeInstallmentPrice"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="정산방식" prop="billingType">
            <el-select style="width:100%" :size="formSize" v-model="media.billingType" @change="changeBillingType"
                       :disabled="isDetail === 'pre'">
              <el-option
                label="월납"
                value="M"></el-option>
              <el-option
                label="분납"
                value="D"></el-option>
              <el-option
                label="일시납"
                value="Y"></el-option>
              <el-option
                label="없음"
                value="EMPTY"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="media.billingType === 'D'">
          <el-form-item label="분납개월수" prop="month">
            <el-select style="width:100%" :size="formSize" v-model="media.month" :disabled="isDetail === 'pre'">
              <el-option v-for="f in 12"
                         :key="f"
                         :value="f"
                         :label="f"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

      </el-row>
      <el-row class="mt-3">
        <el-col :span="8">
          <el-form-item label="층" prop="storeFloorSeq">
            <el-select style="width:100%" :size="formSize" v-model="media.storeFloorSeq" :disabled="isDetail === 'pre'">
              <el-option v-for="item in $store.state.store.storeFloors"
                         :key="item.storeFloorSeq"
                         :label="item.floorType === 'F' ? item.floor + item.floorType : item.floorType + item.floor"
                         :value="item.storeFloorSeq"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="위치(번호)" prop="positionNumber">
            <el-select style="width:100%" :size="formSize" v-model="media.positionNumber" :disabled="isDetail === 'pre'">
              <el-option v-for="n in 100"
                         :key="n"
                         :label="n"
                         :value="n"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="위치(알파벳)">
            <el-select style="width:100%" :size="formSize" v-model="media.positionCode" :disabled="isDetail === 'pre'">
              <el-option
                label="없음"
                value=""></el-option>
              <el-option v-for="n in letters"
                         :key="n"
                         :label="n"
                         :value="n"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item label="팀">
            <el-input :size="formSize" v-model="media.team" :disabled="isDetail === 'pre'"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="대분류">
            <el-input :size="formSize" v-model="media.category" :disabled="isDetail === 'pre'"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="위치안내">
            <el-input :size="formSize" v-model="media.positionInfo" :disabled="isDetail === 'pre'"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item label="IN/OUT" prop="inOut">
            <el-radio-group :size="formSize" v-model="media.inOut" :disabled="isDetail === 'pre'">
              <el-radio-button :size="formSize" label="IN"></el-radio-button>
              <el-radio-button :size="formSize" label="OUT"></el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="사진" prop="upload" v-if="isDetail !== 'pre'">
            <el-upload
              :size="formSize"
              class="upload-demo media-upload"
              ref="upload"
              action="/api/media"
              :multiple="false"
              :headers="header"
              :data="getFormParam"
              :limit="1"
              :on-success="handleSuccess"
              :auto-upload="false">
              <el-button slot="trigger" size="small" >사진 선택</el-button>
            </el-upload>
          </el-form-item>

        </el-col>
      </el-row>
      <el-row class="mt-3">
        <el-col :span="8">
          <el-form-item label="교체일">
            <el-input :size="formSize" v-model="media.replacementDate" :disabled="isDetail === 'pre'"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="부킹여부">
            <el-input :size="formSize" v-model="media.etc" :disabled="isDetail === 'pre'"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="교체 이미지 시안명">
            <el-input :size="formSize" v-model="media.draftName" :disabled="isDetail === 'pre'"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <div class="card-footer text-right">
        <el-button v-if="isDetail !== 'edit' && isDetail !== 'pre'" type="primary" @click="submitUpload('media')">등록
        </el-button>
        <el-button v-if="isDetail !== 'edit' && isDetail !== 'pre'" @click.prevent="resetForm('media')">리셋</el-button>
        <el-checkbox v-if="isDetail === 'edit'" v-model="isCreate" style="margin-right: 20px">이전 광고 저장 여부</el-checkbox>
        <el-button v-if="isDetail === 'edit'"  @click="submitUpload('media')">수정</el-button>
        <el-button v-if="isDetail === 'edit'" type="primary" @click.prevent="close()">닫기</el-button>
      </div>
    </el-form>
  </card>
</template>

<script>

  import Vue from 'vue'
  import {
    Select,
    Form,
    FormItem,
    Button,
    Option,
    Input,
    Row,
    Col,
    Table,
    TableColumn,
    Switch,
    RadioButton,
    RadioGroup,
    Upload,
    DatePicker,
    Checkbox
  } from 'element-ui';
  import MediaProxy from "@/proxies/MediaProxy";
  import CompanyProxy from "@/proxies/CompanyProxy";
  import locale from 'element-ui/lib/locale/lang/ko';
  import MediaInfoProxy from "@/proxies/MediaInfoProxy";
  import MapComponent from "../Common/MapComponent";

  Vue.use(Table);
  Vue.use(TableColumn);
  Vue.use(DatePicker, {locale});

  export default {
    name: "MediaRegistration",
    props: [
      'isDetail',
      'advertisementSeq',
      'storeSeq',
      'areaSeq'
    ],
    components: {
      elSelect: Select,
      elForm: Form,
      elFormItem: FormItem,
      elButton: Button,
      elOption: Option,
      elInput: Input,
      elRow: Row,
      elCol: Col,
      elSwitch: Switch,
      elRadioButton: RadioButton,
      elRadioGroup: RadioGroup,
      elUpload: Upload,
      elCheckbox: Checkbox,
      MapComponent,
    },
    computed: {
      letters() {
        let letters = []
        for (let i = "a".charCodeAt(0); i <= "z".charCodeAt(0); i++) {
          letters.push(String.fromCharCode([i]))
        }
        return letters
      },
      getFormParam: function () {
        return this.media;
      }
    },
    created: function () {
      this.$store.dispatch('store/getAreaList');
      this.changeArea();
      this.getAdvertisers();
      if (this.isDetail === "edit") {
        this.$store.dispatch('common/setMenuTitle', "광고상세");
        new MediaProxy()
          .find(this.advertisementSeq)
          .then((response) => {
            this.bindingMedia(response);
          });
      } else if (this.isDetail === "pre") {
        this.isVisible = false;
        new MediaProxy()
          .find(this.advertisementSeq)
          .then((response) => {
            let advertisement = response.advertisement;
            // 이전 광고 조회
            if (advertisement.mediaType === "WC") {
              new MediaProxy()
                .findByIdPreAdvertisement(advertisement.advertisementSeq)
                .then((response) => {
                  if (response.header.returnCode === "OK") {
                    this.media = response.advertisement;
                    this.media.width = this.numberWithCommas(response.advertisement.width.toString());
                    this.media.height = this.numberWithCommas(response.advertisement.height.toString());
                    this.media.prepaymentPrice = this.numberWithCommas(response.advertisement.prepaymentPrice.toString());
                    this.media.installmentPrice = this.numberWithCommas(response.advertisement.installmentPrice.toString());
                    this.media.storeSeq = response.advertisement.storeSeq;
                    this.media.areaSeq = this.areaSeq;
                    this.getMediaInfos(this.media.mediaType);
                    this.changeStore(this.storeSeq);
                    this.isCreate = true;
                    this.isVisible = true;
                    this.mapView = true;
                  }
                })
            }

          });
      } else {
        this.$store.dispatch('common/setMenuTitle', "광고 개별 등록");
        this.isCreate = true;
        this.formSize = ''
      }
    },
    methods: {
      bindingMedia(response) {
        console.log(response.advertisement);
        this.media = response.advertisement;
        this.media.width = this.numberWithCommas(response.advertisement.width.toString());
        this.media.height = this.numberWithCommas(response.advertisement.height.toString());
        this.media.prepaymentPrice = this.numberWithCommas(response.advertisement.prepaymentPrice.toString());
        this.media.installmentPrice = this.numberWithCommas(response.advertisement.installmentPrice.toString());
        this.media.storeSeq = response.advertisement.storeSeq;
        this.getMediaInfos(this.media.mediaType);
        this.changeStore(this.storeSeq);
        this.isCreate = true;
        this.mapView = true;
      },
      close() {
        // this.$emit('closeEdit', false);
        window.close();
      },
      tableRowStyle() {
        return this.$store.state.common.tableHeaderCellStyle;
      },
      changeArea(value) {
        if (this.isDetail !== 'edit' && this.isDetail !== 'pre') {
          this.media.storeSeq = '';
        }
        let param = {
          searchAreaSeq: value
        };
        this.$store.dispatch('store/findAll', param);
      },
      getAdvertisers() {
        let param = {
          roleCode: "ADVERTISER",
          searchKey: encodeURI(encodeURIComponent(this.searchCompanyName)),
          rows: 10000
        };
        this.$store.dispatch('settingsCompany/findAll', param);
      },
      changeCompanyName(value) {
        this.media.companySeq = '';
        // 초성으로 광고주 검색
        this.getAdvertisers();
      },
      // 광고주 선택
      changeCompany(value) {
        // 사업자 번호 설정
        new CompanyProxy()
          .find(value)
          .then((response) => {
            this.media.licenseNumber = response.company.licenseNumber;
          });
      },
      getMediaInfos(value) {
        if (this.isDetail !== 'edit' && this.isDetail !== 'pre') {
          this.media.mediaInfoSeq = '';
        }
        if (value === "WC") {
          this.media.duration = 0;
        }
        let param = {
          searchMediaType: value
        };
        this.$store.dispatch('media/findAll', param);
      },
      changeStore(value) {
        // 매장 층 정보조회
        this.$store.dispatch('store/findAllStoreFloors', value);
      },
      submitUpload(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (this.$refs.upload.uploadFiles.length > 0 || !this.isCreate) {
              this.media.isCreate = this.isCreate;
              if (this.$refs.upload.uploadFiles.length > 0) {
                this.$refs.upload.submit();
              } else {
                this.media.regDate = '';
                this.media.width = Vue.FilterNumber(this.media.width);
                this.media.height = Vue.FilterNumber(this.media.height);
                this.media.prepaymentPrice = Vue.FilterNumber(this.media.prepaymentPrice);
                this.media.installmentPrice = Vue.FilterNumber(this.media.installmentPrice);
                new MediaProxy()
                  .updateAdvertisement(this.media)
                  .then((response) => {
                    alert("수정이 완료되었습니다.");
                    this.$emit('updateComplete', false);
                  })
              }
            } else {
              alert("사진을 선택하세요.");
            }
          } else {
            return false;
          }
        });
      },
      handleSuccess(response, files, fileList) {
        if (response.header.returnCode === "OK") {
          if (this.isDetail === "edit") {
            // 수정화면
            alert("수정이 완료되었습니다.");
            this.$emit('updateComplete', false);
            self.close();
            /*
            new MediaProxy()
              .find(this.advertisementSeq)
              .then((response) => {
                this.$emit('updateComplete', false);
                this.bindingMedia(response);
              });
            */

          } else {
            // 등록화면
            alert("등록이 완료되었습니다.");
            this.$refs.upload.clearFiles();
            this.resetForm('media');
            this.media.licenseNumber = '';
            this.media.etc = '';
            this.media.draftName = '';
            this.media.replacementDate = '';
          }
        } else {
          this.$refs.upload.clearFiles();
          alert(response.header.resultMessages);
        }
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      changeMedia(value) {
        new MediaInfoProxy()
          .find(value)
          .then((response) => {
            this.media.isLight = response.mediaInfo.isLight;
            this.media.duration = response.mediaInfo.duration;
            this.media.width = this.numberWithCommas(response.mediaInfo.width.toString());
            this.media.height = this.numberWithCommas(response.mediaInfo.height.toString());
            this.media.prepaymentPrice = this.numberWithCommas(response.mediaInfo.prepaymentPrice.toString());
            this.media.installmentPrice = this.numberWithCommas(response.mediaInfo.installmentPrice.toString());
            this.media.inOut = response.mediaInfo.inOut;
          })
      },
      formatDate(date) {
        let d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

        if (month.length < 2)
          month = '0' + month;
        if (day.length < 2)
          day = '0' + day;

        return [year, month, day].join('-');
      },
      numberWithCommas(x) {
        return Vue.NumberWithCommas(x);
      },
      changeWidth(event) {
        this.media.width = this.numberWithCommas(this.media.width);
      },
      changeHeight(event) {
        this.media.height = this.numberWithCommas(this.media.height);
      },
      changePrepaymentPrice(event) {
        this.media.prepaymentPrice = this.numberWithCommas(this.media.prepaymentPrice);
      },
      changeInstallmentPrice(event) {
        this.media.installmentPrice = this.numberWithCommas(this.media.installmentPrice);
      },
      changeBillingType(value) {
        if(value !== "D") {
          this.media.month = 0;
        }
      },
      changeProfit(value) {
        if(value !== "INCOMING") {
          this.media.prepaymentPrice = "0";
          this.media.installmentPrice = "0";
          this.media.billingType = "EMPTY";
        }
      },
    },
    data() {
      let checkInOut = (rule, value, callback) => {
        if (this.media.inOut === '') {
          alert("IN/OUT을 선택하세요.");
          callback(new Error('IN/OUT을 선택하세요.'));
        } else {
          callback();
        }
      };
      return {
        formSize: 'mini',
        mapView: false,
        isVisible: true,
        isCreate: true,
        media: {
          areaSeq: '',
          storeSeq: '',
          companySeq: '',
          licenseNumber: '',
          mediaType: '',
          goodsName: '',
          mediaInfoSeq: '',
          width: '',
          height: '',
          prepaymentPrice: '',
          installmentPrice: '',
          positionInfo: '',
          storeFloorSeq: '',
          positionNumber: '',
          positionCode: '',
          inOut: '',
          isLight: false,
          billingType: '',
          status: '',
          replacementDate: '',
          etc: '',
          profit: '',
          team: '',
          category: '',
          duration: '',
          month: '',
          draftName: '',
          isCreate: false,
        },
        searchCompanyName: '',
        keywordOptions: [
          {label: '전체', value: ''},
          {label: '가', value: '가'},
          {label: '나', value: '나'},
          {label: '다', value: '다'},
          {label: '라', value: '라'},
          {label: '마', value: '마'},
          {label: '바', value: '바'},
          {label: '사', value: '사'},
          {label: '아', value: '아'},
          {label: '자', value: '자'},
          {label: '차', value: '차'},
          {label: '카', value: '카'},
          {label: '타', value: '타'},
          {label: '파', value: '파'},
          {label: '하', value: '하'},
          {label: 'A-z', value: 'a'}
        ],
        rules: {
          /*                    areaSeq: [
                                  { required: true, message: '지역을 선택하세요.', trigger: 'change' }
                              ],*/
          storeSeq: [
            {required: true, message: '매장을 선택하세요.', trigger: 'change'}
          ],
          companySeq: [
            {required: true, message: '광고주를 선택하세요.', trigger: 'change'}
          ],
          goodsName: [
            {required: true, message: '상품명을 입력하세요.', trigger: 'blur'}
          ],
          mediaType: [
            {required: true, message: '매체구분을 선택하세요.', trigger: 'change'}
          ],
          mediaInfoSeq: [
            {required: true, message: '광고매체를 선택하세요.', trigger: 'change'}
          ],
          storeFloorSeq: [
            {required: true, message: '층을 선택하세요.', trigger: 'change'}
          ],
          positionNumber: [
            {required: true, message: '위치를 선택하세요.', trigger: 'change'}
          ],
          positionInfo: [
            {required: true, message: '위치안내를 입력하세요.', trigger: 'blur'}
          ],
          duration: [
            {required: true, message: '송출시간을 입력하세요.', trigger: 'blur'}
          ],
          billingType: [
            {required: true, message: '정산방식을 선택하세요.', trigger: 'change'}
          ],
          profit: [
            {required: true, message: '현황구분을 선택하세요.', trigger: 'change'}
          ],
          width: [
            {required: true, message: '넓이을 입력하세요.', trigger: 'blur'}
          ],
          height: [
            {required: true, message: '높이를 입력하세요.', trigger: 'blur'}
          ],
          prepaymentPrice: [
            {required: true, message: '연광고료를 입력하세요.', trigger: 'blur'}
          ],
          installmentPrice: [
            {required: true, message: '월광고료를 입력하세요.', trigger: 'blur'}
          ],
          inOut: [
            {required: true, validator: checkInOut, trigger: 'change'}
          ],
          replacementDate: [
            {required: true, message: '교체일을 입력하세요.', trigger: 'blur'}
          ],
          month: [
            {required: true, message: '개월수를 선택하세요.', trigger: 'change'}
          ]
        },
        header: {
          Authorization: $cookies.get('id_token')
        },
      }
    },
  }
</script>

<style scoped>


</style>

<style scoped>
  .el-form-item {
    margin-bottom: 0px !important;
  }

  .el-select .el-input:hover .el-input__icon, .el-select .el-input:hover input {
    color: #212529 !important;
  }

  .bg-purple-light {
    background: #f8f9fc;
  }
  .media-upload  {
    display: flex;
    width: 100%;
  }
  .media-upload .el-upload-list--text {
    margin-left: 10px;
  }
</style>
